import { render, staticRenderFns } from "./OtherSuppliersList.vue?vue&type=template&id=1a65422e&scoped=true&"
import script from "./OtherSuppliersList.vue?vue&type=script&lang=js&"
export * from "./OtherSuppliersList.vue?vue&type=script&lang=js&"
import style0 from "./OtherSuppliersList.vue?vue&type=style&index=0&id=1a65422e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a65422e",
  null
  
)

export default component.exports